import { DatePicker, Form, Select } from "antd";
import React from "react";
import { useTranslation } from "react-i18next";
import { TFunction } from "i18next";

import moment from "moment";

import type { ExportSusaFormValues } from "./types";

const MONTH_OPTIONS = [
  "Januar",
  "Februar",
  "März",
  "April",
  "Mai",
  "Juni",
  "Juli",
  "August",
  "September",
  "Oktober",
  "November",
  "Dezember",
].map((label, index) => ({ value: index + 1, label }));

export const initialExportSusaValues: Partial<ExportSusaFormValues> = {
  date: moment(),
  fromMonth: 1,
  toMonth: 12,
};

const getTexts = (t: TFunction) => {
  const keyPrefix = "command.exportSusa";
  return {
    date: {
      label: t(`${keyPrefix}.date.label`, "Fiscal year"),
      placeholder: t(`${keyPrefix}.date.placeholder`, "Select fiscal year"),
    },
    fromMonth: {
      label: t(`${keyPrefix}.fromMonth.label`, "From month"),
    },
    toMonth: {
      label: t(`${keyPrefix}.toMonth.label`, "To month"),
    },
  };
};

export const ExportSusa: React.FC = () => {
  const { t } = useTranslation("CommandHub");
  const texts = getTexts(t);

  return (
    <>
      <Form.Item
        name="date"
        label={texts.date.label}
        initialValue={initialExportSusaValues.date}
      >
        <DatePicker
          id="susa-date"
          placeholder={texts.date.placeholder}
          picker="year"
          disabledDate={(date: moment.Moment) =>
            date && date.year() > moment().year()
          }
        />
      </Form.Item>

      <Form.Item
        name="fromMonth"
        label={texts.fromMonth.label}
        initialValue={initialExportSusaValues.fromMonth}
      >
        <Select id="susa-from-month" options={MONTH_OPTIONS} />
      </Form.Item>

      <Form.Item
        name="toMonth"
        label={texts.toMonth.label}
        initialValue={initialExportSusaValues.toMonth}
      >
        <Select id="susa-to-month" options={MONTH_OPTIONS} />
      </Form.Item>
    </>
  );
};

export default ExportSusa;
